import styled from '@emotion/styled';
import Button from '../../components/Button/Button';
import Link from '../../components/Link/Link';
import rem from '../../utils/rem/rem';
import { Buttons, Message } from '../../common/TwoButtonModal/TwoButtonModal.styles';

export const StyledExtendedHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.gray200};
  padding: ${rem(24)} ${rem(32)} ${rem(32)} ${rem(32)};
  margin-bottom: ${rem(32)};
`;

export const StyledLink = styled(Link)`
  width: max-content;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const Title = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(30)};
  margin-top: ${rem(8)};
`;

export const DropdownWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: ${rem(24)};
  padding-bottom: ${rem(12)};
  width: ${rem(323)};
`;

export const TextButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledTextButton = styled(Button)`
  margin-right: ${rem(10)};
  width: max-content;
`;

export const ManInvPage = styled.div`
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
`;

export const StyledMessage = styled(Message)`
  margin-bottom: ${rem(16)};
`;

export const StyledButtons = styled(Buttons)`
  margin-top: ${rem(32)};
`;

